var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconsFalafelMenu({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons-falafel-menu",
    transform: "translate(-425.1 -56)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "bounding",
    width: 30,
    height: 30,
    transform: "translate(425.1 56)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14851",
    "data-name": "Path 14851",
    d: "M28.884,42.643A2.644,2.644,0,1,1,26.24,40,2.644,2.644,0,0,1,28.884,42.643ZM34.336,40a2.644,2.644,0,1,0,2.644,2.644A2.644,2.644,0,0,0,34.336,40ZM18.144,40a2.644,2.644,0,1,0,2.644,2.644A2.644,2.644,0,0,0,18.144,40Z",
    transform: "translate(413.6 28.001)",
    fill: "#8c9499"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsFalafelMenu);
export default __webpack_public_path__ + "static/media/icons-falafel-menu.f16064a7.svg";
export { ForwardRef as ReactComponent };